module.exports = __webpack_public_path__ + "static/maggie-aae3c860f89680f26f381c8d094fa169.jpg";